import { type OfferShippingsV1 } from '@redteclab/api/clients/bully'

export const shippingAccessotGetDeliveryThresholdByCode = ({
  code,
  shippings,
}: {
  code: OfferShippingsV1['shippingTypeCode']
  shippings: OfferShippingsV1[] | null | undefined
}): number | null | undefined =>
  (shippings ?? []).find((shipping) => code === shipping.shippingTypeCode)
    ?.shippingFreeAmount
